import SessionEventProto from "../session-event-proto";
import asyncSessionLoader from "../../gd/data/async-session-loader";
import Chat from "../../model2/chat/chat/chat";
import {EVENT_BUS_CHAT_NEW} from "../../model2/chat/chat/const";


export default class SessionEvent_ChatRoomNew extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    findMissingData() {
        const users         = this.data.users;
        if (this.data.user1Id) users.push(this.data.user1Id);
        if (this.data.user2Id) users.push(this.data.user2Id);

        return gd.session.findMissing({
            projects    : [this.data.projectId],
            users       : _.uniq(users)
        });
    }

    async process() {
        if (this.isDifferentCompany()) return false;

        if (!gd.session.chatsLoaded || !gd.session.chats) {
            // well no chats in session so ignore I guess ?
            // gd.session.chats = new ChatCollection(this.data,{parse:true});
            return
        }

        await asyncSessionLoader(this.findMissingData())

        const chat : Chat  = new Chat(this.data)
        gd.session.chats.add(chat)

        gd.bus.triggerEvent(EVENT_BUS_CHAT_NEW, this.data);
    }
}